(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/device-services/assets/javascripts/web/web-orientation-service.js') >= 0) return;  svs.modules.push('/components/tur/device-services/assets/javascripts/web/web-orientation-service.js');

'use strict';

class WebOrientationService {
  constructor() {
    this.callbacks = new Set();
    this.listening = false;
    this.permissionGranted = false;
    this.handleOrientation = event => {
      var _event$gamma, _event$beta, _event$alpha;
      const data = {
        roll: (_event$gamma = event.gamma) !== null && _event$gamma !== void 0 ? _event$gamma : 0,
        pitch: (_event$beta = event.beta) !== null && _event$beta !== void 0 ? _event$beta : 90,
        yaw: (_event$alpha = event.alpha) !== null && _event$alpha !== void 0 ? _event$alpha : 0
      };
      this.callbacks.forEach(cb => {
        try {
          cb(data);
        } catch (e) {
        }
      });
    };
  }
  async start() {
    if (this.listening) {
      return;
    }
    if (!this.permissionGranted) {
      const granted = await this.requestPermission();
      if (!granted) {
        return;
      }
    }
    this.listening = true;
    window.addEventListener('deviceorientation', this.handleOrientation);
  }
  stop() {
    this.listening = false;
    window.removeEventListener('deviceorientation', this.handleOrientation);
  }
  onData(callback) {
    this.callbacks.add(callback);
    return () => {
      this.callbacks.delete(callback);
    };
  }
  async requestPermission() {
    const orientationEvent = window.DeviceOrientationEvent;
    if (!orientationEvent) {
      return false;
    }
    if (typeof orientationEvent.requestPermission !== 'function') {
      this.permissionGranted = true;
      return true;
    }
    try {
      const response = await orientationEvent.requestPermission();
      this.permissionGranted = response === 'granted';
      return this.permissionGranted;
    } catch (e) {
      return false;
    }
  }
}
setGlobal('svs.tur.device.WebOrientationService', WebOrientationService);

 })(window);